import { IMPACT_POINTS, LOCATION, MISSION_SHORT, ORGANIZATION_NAME, TAGLINE } from '../constants';
import { jumpToAnchor } from '../utils/anchor-navigation';

function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-hub-cream bg-warm-glow">
      <div className="absolute inset-0 bg-soft-grid bg-grid-32 opacity-50" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-5 py-20 md:grid-cols-12 md:items-end md:py-28">
        <div className="md:col-span-7">
          <p className="mb-6 inline-flex rounded-full border border-hub-forest/15 bg-hub-paper/80 px-4 py-2 text-xs font-black uppercase tracking-[0.24em] text-hub-forest">
            {LOCATION}
          </p>
          <h1 className="font-display text-5xl font-bold leading-[0.98] text-hub-forest md:text-7xl lg:text-[88px]">
            {TAGLINE}
          </h1>
          <p className="mt-7 max-w-2xl text-lg leading-8 text-hub-muted md:text-xl">
            {MISSION_SHORT}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#programs" onClick={(event) => jumpToAnchor(event, '#programs')} className="rounded-full bg-hub-forest px-7 py-4 text-sm font-black uppercase tracking-[0.18em] text-hub-cream transition hover:bg-hub-coral">
              Explore programs
            </a>
            <a href="#contact" onClick={(event) => jumpToAnchor(event, '#contact')} className="rounded-full border border-hub-forest/25 bg-hub-paper px-7 py-4 text-sm font-black uppercase tracking-[0.18em] text-hub-forest transition hover:border-hub-coral hover:text-hub-coral">
              Start a conversation
            </a>
          </div>
        </div>

        <aside className="md:col-span-5">
          <div className="rounded-[2rem] border border-hub-forest/10 bg-hub-paper/90 p-5 shadow-soft md:p-7">
            <div className="rounded-[1.5rem] bg-hub-sun/70 p-6">
              <p className="text-sm font-black uppercase tracking-[0.24em] text-hub-forest/70">Daily good</p>
              <p className="mt-5 font-display text-3xl font-bold leading-tight text-hub-forest">
                A hub for belonging, contribution, and steady encouragement.
              </p>
            </div>
            <div className="mt-5 grid gap-3 sm:grid-cols-3">
              {IMPACT_POINTS.map((item) => (
                <div key={item.label} className="rounded-3xl bg-hub-mint p-4">
                  <p className="font-display text-2xl font-bold text-hub-forest">{item.value}</p>
                  <p className="mt-1 text-xs font-bold uppercase tracking-[0.16em] text-hub-muted">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </div>
      <p className="sr-only">{ORGANIZATION_NAME}</p>
    </section>
  );
}

export default Hero;
